// extracted by mini-css-extract-plugin
module.exports = {"teamLogoUrl":"TeamLogoUrl_teamLogoUrl_37i9a"};